var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMieterwechsel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62.5 65.3",
    style: {
      enableBackground: "new 0 0 62.5 65.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,39.3c-0.3,0-0.7,0-0.9,0.2c-0.3,0.2-0.4,0.5-0.5,0.8C55.8,52,46,59.9,32.4,60.6c-13.4,0.7-25-8.9-27-22 l0.2,0.2c0.2,0.4,0.7,0.6,1.1,0.6c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.3,0-0.7-0.2-0.9l-2.7-4.2 c-0.2-0.4-0.7-0.6-1.1-0.6S3,33,2.8,33.4l-2.3,4.4c-0.3,0.6-0.1,1.4,0.5,1.7s1.4,0.1,1.7-0.5l0.2-0.4c1.9,14.1,14,24.6,28.2,24.6 c0.5,0,1,0,1.5,0c14.6-0.8,25.5-9.7,27.2-22.4C59.9,40,59.4,39.4,58.8,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,29L61.5,29c-0.6-0.3-1.3-0.1-1.7,0.5l-0.2,0.3c-1.2-14.6-13.5-26-28.4-26c-13.7,0-25.4,9.7-28,23.1 c-0.1,0.7,0.3,1.3,1,1.4c0.7,0.1,1.3-0.3,1.4-1C8,15.1,18.8,6.2,31.2,6.2c13.4,0,24.6,10.2,25.9,23.5L57,29.5 c-0.3-0.6-1.1-0.8-1.7-0.5c-0.6,0.3-0.8,1.1-0.5,1.7l2.5,4.3c0.2,0.4,0.6,0.6,1.1,0.6s0.9-0.2,1.1-0.6l2.5-4.3 C62.3,30.1,62.1,29.3,61.5,29z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,21h-1.7c-1.2,0-1.6,0.1-1.8,0.2c-0.1,0-0.2,0.1-0.4,0.4c-0.1,0.3-0.4,0.9-0.7,2.1l-3.9,14.9 c-0.1,0.5-0.6,0.9-1.2,0.9s-1.1-0.4-1.2-0.9l-3.9-14.9c-0.3-1.3-0.6-1.9-0.7-2.1c-0.1-0.2-0.2-0.3-0.4-0.4c-0.1-0.1-0.6-0.2-1.8-0.2 h-1.7c-0.8,0-1.4,0.1-1.8,0.4c-0.2,0.2-0.4,0.7-0.4,1.4v21.5c0,0.7,0.1,1.2,0.4,1.5c0.2,0.2,0.5,0.4,0.9,0.4c0.5,0,0.8-0.2,0.9-0.4 c0.2-0.3,0.4-0.8,0.4-1.5V25.5c0-0.6,0.5-1.2,1.1-1.2c0.6-0.1,1.2,0.3,1.4,0.9l4.3,17.3c0.1,0.6,0.3,1.1,0.4,1.6 c0.1,0.4,0.3,0.8,0.5,1.1c0.1,0.3,0.3,0.5,0.6,0.6c0.2,0.2,0.6,0.2,1,0.2c0.5,0,0.9-0.1,1.2-0.3c0.3-0.3,0.5-0.6,0.6-0.9 c0.2-0.5,0.4-1.3,0.7-2.4l4.3-17.3c0.1-0.6,0.6-0.9,1.2-0.9c0.1,0,0.1,0,0.2,0c0.6,0.1,1.1,0.6,1.1,1.2v18.7c0,0.7,0.1,1.2,0.4,1.5 c0.2,0.3,0.5,0.4,0.9,0.4c0.5,0,0.8-0.2,0.9-0.4c0.2-0.3,0.4-0.8,0.4-1.5V22.7c0-0.7-0.1-1.2-0.4-1.4C42.3,21.1,41.7,21,40.9,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMieterwechsel);
export default __webpack_public_path__ + "static/media/Mieterwechsel.763779d56e17a4742579591a04dd0c3e.svg";
export { ForwardRef as ReactComponent };